import React, { useState, useEffect } from 'react';

import EmptyError from 'components/AlertScreens/EmptyError';
import TableSkeletonLoader from 'components/AlertScreens/TableSkeletonLoader';
import { Divider1 } from 'styles/common';

import { StyledTablePagination } from '../../Reviews/ReviewTemplate/common/styles';
import SearchTemplates from './SearchTemplate';
import TemplateListHeader from './TemplateHeader';
import TemplateRow from './TemplateRow';

const TemplateList = ({
  templates,
  loading,
  noDataMessage = '',
  noDataSubMessage = '',
  handleOpenTemplate,
  currentTab,
  handleArchiveTemplate,
  handleDuplicateTemplate,
}) => {
  const [search, setSearch] = useState({
    text: '',
    creator: '',
  });
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredTemplates, setFilteredTemplates] = useState([]);
  const limit = 10;

  const creators = [
    { label: 'All', value: 'ALL' },
    ...[...new Set(templates.map((temp) => temp.createdByEmployee))].map((temp) => ({
      label: temp,
      value: temp,
    })),
  ];

  useEffect(() => {
    if (templates && templates.length > 0) {
      filterData(search, templates, currentPage);
    }
  }, [templates]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    filterData(search, templates, page);
  };

  const filterData = (searchData, data, page) => {
    let result = [...data];
    if (searchData.text) {
      result = result.filter((temp) => temp.name.toLowerCase().includes(searchData.text.toLowerCase()));
    }
    if (searchData.creator && searchData.creator !== 'ALL') {
      result = result.filter((temp) => temp.createdByEmployee === searchData.creator);
    }
    setCount(result.length);
    setFilteredTemplates(result.filter((r, i) => i >= page * limit && i < (page + 1) * limit));
  };

  const onSearchChange = (param, value) => {
    setCurrentPage(0);
    const searchData = { ...search, [param]: value };
    setSearch(searchData);
    filterData(searchData, templates, 0);
  };

  return (
    <>
      <SearchTemplates search={search} onSearchChange={onSearchChange} creators={creators} />
      <Divider1 bottomGutter={1} />
      <TemplateListHeader />
      <Divider1 topGutter={1} />

      {filteredTemplates.length || loading ? (
        loading ? (
          <TableSkeletonLoader />
        ) : (
          <>
            {filteredTemplates.map((template) => (
              <React.Fragment key={template.id}>
                <TemplateRow
                  currentTab={currentTab}
                  template={template}
                  handleClick={handleOpenTemplate}
                  handleArchiveClick={handleArchiveTemplate}
                  handleDuplicateClick={handleDuplicateTemplate}
                />
              </React.Fragment>
            ))}
          </>
        )
      ) : (
        <EmptyError errorMessage={noDataMessage} errorSubtitle={noDataSubMessage} />
      )}
      <StyledTablePagination
        component="div"
        count={count}
        rowsPerPage={limit}
        rowsPerPageOptions={[]}
        page={currentPage}
        onChangePage={(e, newPage) => handlePageChange(newPage)}
        labelRowsPerPage={null}
      />
    </>
  );
};

export default TemplateList;
